module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_21-e78f5a1f1ec6b0e11e02efdb3884d0b6.jpg";